module.exports = __webpack_public_path__ + "img/img_52@2x.2de2dcd7.png";